var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4 0.5H10.5L18 8V19.1C18 20.4255 16.9255 21.5 15.6 21.5H2.4C1.07452 21.5 0 20.4255 0 19.1V2.9C0 1.57452 1.07452 0.5 2.4 0.5ZM15.6 19.625H2.4C2.11005 19.625 1.875 19.3899 1.875 19.1V2.9C1.875 2.61005 2.11005 2.375 2.4 2.375H9.26221V6.50059C9.26221 8.01246 10.4878 9.23809 11.9997 9.23809H16.125V19.1C16.125 19.3899 15.8899 19.625 15.6 19.625ZM14.7114 7.36309L11.1372 3.78886V6.50059C11.1372 6.97693 11.5234 7.36309 11.9997 7.36309H14.7114Z",
    fill: "#F2F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.75V13.75H13.5V11.75H4.5ZM4.5 17.25H10.7V15.25H4.5V17.25Z",
    fill: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDoc);
export default __webpack_public_path__ + "static/media/viewDoc.6af3ba1c76bbccc29cc3a633eafed8e6.svg";
export { ForwardRef as ReactComponent };